import type {Filter} from '@superweb/ui'
import {useI18n} from '@yandex-delivery/core/i18n'
import {useMemo} from 'react'

import {useFilters} from '../../../../../../../hooks'
import type {BaseUIProps, Props} from '../model'

export function useController(props: Props): BaseUIProps {
  const {tariffsCargoInfo} = props

  const {filters: rawFilters} = tariffsCargoInfo
  const i18n = useI18n()
  const {filters: filtersValue, setFilter: setFilterValue} = useFilters()

  const label = i18n('tariffs-v3.tariff-info.filters', 'Фильтры')
  const filters = useMemo(() => {
    return rawFilters.map<Filter>(filter => {
      const options = filter.options.map(option => {
        return {
          value: option.value,
          label: option.name,
        }
      })
      const selected = options.find(option => {
        return option.value === filtersValue[filter.id]
      })

      return {
        key: filter.id,
        label: i18n(`tariffs-v3.tariff-info.filter.${filter.id}`, filter.id),
        type: 'single-choice',
        onChange: state => {
          setFilterValue(filter.id, state.selected?.value)
        },
        options,
        state: {
          selected,
        },
        valueReplacesLabel: true,
      }
    })
  }, [rawFilters, filtersValue, setFilterValue, i18n])

  return {
    filters,
    label,
  }
}
